import { Download } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import type { ExportReportType } from "@/services/admin-api";

interface ExportDataPanelProps {
  exportType: ExportReportType;
  exportStartDate: string;
  exportEndDate: string;
  isExporting: boolean;
  onExportTypeChange: (type: ExportReportType) => void;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onExport: () => void;
}

export function ExportDataPanel({
  exportType,
  exportStartDate,
  exportEndDate,
  isExporting,
  onExportTypeChange,
  onStartDateChange,
  onEndDateChange,
  onExport,
}: ExportDataPanelProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Export Data</CardTitle>
        <CardDescription>Download reports as CSV with optional filters</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="grid gap-4 md:grid-cols-4">
            <div>
              <label className="text-sm font-medium">Report Type</label>
              <select
                value={exportType}
                onChange={(e) => onExportTypeChange(e.target.value as ExportReportType)}
                className="mt-1 w-full rounded-md border bg-background px-3 py-2 text-sm"
              >
                <option value="users">Users</option>
                <option value="subscriptions">Subscriptions</option>
                <option value="payments">Payments</option>
                <option value="ai-usage">AI Usage</option>
                <option value="audit-logs">Audit Logs</option>
              </select>
            </div>
            <div>
              <label className="text-sm font-medium">Start Date</label>
              <input
                type="date"
                value={exportStartDate}
                onChange={(e) => onStartDateChange(e.target.value)}
                className="mt-1 w-full rounded-md border bg-background px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm font-medium">End Date</label>
              <input
                type="date"
                value={exportEndDate}
                onChange={(e) => onEndDateChange(e.target.value)}
                className="mt-1 w-full rounded-md border bg-background px-3 py-2 text-sm"
              />
            </div>
            <div className="flex items-end">
              <Button onClick={onExport} disabled={isExporting}>
                <Download className="mr-2 h-4 w-4" />
                {isExporting ? "Exporting..." : "Export"}
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
